import React from 'react'

const ICON_VIEWBOX = {
  rmiac18: '-41 -120 1512 1752',
};

const Icon = ({ name, width, height }) => {
  const viewBox = ICON_VIEWBOX[name];

  return (
    <svg
      className={`icon icon-${name}`}
      viewBox={viewBox}
      preserveAspectRatio={viewBox ? 'xMidYMid meet' : undefined}
      overflow="visible"
      style={{ width, height }}
    >
      <use
        xlinkHref={`${process.env.PUBLIC_URL}/images/sprite.svg#${name}`}
      ></use>
    </svg>
  );
};

export default Icon
